var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacetimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2 10.4023H9.46667C8.13333 10.4023 7 11.5357 7 12.869V19.2023C7 20.5357 8.13333 21.669 9.46667 21.669H17.2C18.5333 21.669 19.6667 20.5357 19.6667 19.2023V12.869C19.6667 11.469 18.5333 10.4023 17.2 10.4023Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2666 10.9354L20.6666 13.2021C20.5332 13.3354 20.3999 13.5354 20.3999 13.7354V18.2021C20.3999 18.4021 20.4666 18.6021 20.6666 18.7354L23.2666 21.0687C23.8666 21.6021 24.8666 21.2021 24.8666 20.3354V11.6687C24.8666 10.8021 23.9332 10.3354 23.2666 10.9354Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 4.00195H8.66667C6.06667 4.00195 4 6.06862 4 8.66862V23.3353C4 25.9353 6.06667 28.002 8.66667 28.002H23.3333C25.9333 28.002 28 25.9353 28 23.3353V8.66862C28 6.06862 25.9333 4.00195 23.3333 4.00195ZM19.3333 19.002C19.3333 20.2686 18.2667 21.3353 17 21.3353H9.66667C8.4 21.3353 7.33333 20.2686 7.33333 19.002V13.002C7.33333 11.7353 8.4 10.6686 9.66667 10.6686H17C18.2667 10.6686 19.3333 11.7353 19.3333 13.002V19.002ZM24.6667 19.9353C24.6667 20.6686 23.8 21.0686 23.2 20.602L20.8667 18.5353C20.7333 18.402 20.6667 18.202 20.6667 18.002V14.002C20.6667 13.802 20.7333 13.602 20.8667 13.5353L23.2 11.4686C23.7333 11.002 24.6667 11.3353 24.6667 12.1353V19.9353Z",
    fill: "#00FF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacetimeIcon);
export default __webpack_public_path__ + "static/media/facetime-icon.ed0d60cc8d5fcc0fa49b46573141857e.svg";
export { ForwardRef as ReactComponent };